const CompanyPaidItems = () => {
  return <div>CompanyPaidItems</div>
}

export default CompanyPaidItems
